import { fontSize, radius, space, fontFamily } from '../../Tasks/configs/designTokens';

const GeneratedTagsCardStyles = {
  // Third-party <CodeBlock> theme prop (cannot be SCSS)
  codeBlockTheme: {
    lineNumberColor: "#858585",
    lineNumberBgColor: "#252526",
    backgroundColor: "#1e1e1e",
    textColor: "#d4d4d4",
    substringColor: "#ce9178",
    keywordColor: "#569cd6",
    attributeColor: "#9cdcfe",
    selectorTagColor: "#f92672",
    docTagColor: "#6a9955",
    nameColor: "#dcdcaa",
    builtinColor: "#4ec9b0",
    literalColor: "#b5cea8",
    bulletColor: "#d7ba7d",
    codeColor: "#d4d4d4",
    additionColor: "#b5cea8",
    regexpColor: "#d16969",
    symbolColor: "#d4d4d4",
    variableColor: "#9cdcfe",
    templateVariableColor: "#9cdcfe",
    linkColor: "#569cd6",
    selectorAttributeColor: "#92c5f8",
    selectorPseudoColor: "#dcdcaa",
  },

  // Third-party <CodeBlock customStyle> prop (cannot be SCSS)
  codeBlockCustom: {
    padding: `${space[4]}px 0`,
    margin: "0",
    backgroundColor: "#1e1e1e",
    fontSize: `${fontSize.button}px`,
    lineHeight: "1.6",
    fontFamily: fontFamily.mono,
    borderRadius: `0 0 ${radius.lg}px ${radius.lg}px`,
  }
};

export default GeneratedTagsCardStyles;
